import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { TelegramRouter } from 'telegram-router';
import App from './App';

const tg = (window as any).Telegram?.WebApp;
const colorScheme = tg?.colorScheme ?? 'light';

const theme = createTheme({
  palette: {
    mode: colorScheme,
    ...(colorScheme === 'dark' && {
      background: {
        default: tg?.themeParams?.bg_color ?? '#212121',
        paper: tg?.themeParams?.secondary_bg_color ?? '#2e2e2e',
      },
      text: {
        primary: tg?.themeParams?.text_color ?? '#ffffff',
      },
    }),
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TelegramRouter>
        <App />
      </TelegramRouter>
    </ThemeProvider>
  </React.StrictMode>
);